import { useEffect, useState } from 'react'
import { api } from '../../lib/api'

export interface TenantUser {
  id: string
  username: string
  email: string
  role: string
  active?: number | boolean
}

// Active users of this organization, for owner and assignee pickers
export function useTenantUsers(enabled: boolean) {
  const [users, setUsers] = useState<TenantUser[]>([])
  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    api.getUsers()
      .then(res => {
        if (!cancelled && res.success) setUsers((res.users as TenantUser[]).filter(u => u.active !== 0 && u.active !== false))
      })
      .catch(() => {
        // Pickers stay empty; the dialogs explain there is no one to choose
      })
    return () => { cancelled = true }
  }, [enabled])
  return users
}
